export const ForgotPassword = {
	title: "Glömt lösenord",
	explanation_text: "Ange din e-postadress så skickar vi instruktioner för att återställa ditt lösenord.",
	button_text: "Skicka återställningsinstruktioner",
	button_loading_text: "Skickar återställningsinstruktioner...",
	remember_password_text: "Kommer du ihåg ditt lösenord?",
	login_button_text: "Logga in",
	success_title: "Återställningsinstruktioner skickade!",
	success_explanation_text: `
        Om din e-postadress finns i vårt system kommer du att få instruktioner för att återställa ditt lösenord.
        Vänligen kontrollera din e-post och följ stegen.
    `,
};
